/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchPreset } from './SearchPreset';
import {
    SearchPresetFromJSON,
    SearchPresetFromJSONTyped,
    SearchPresetToJSON,
    SearchPresetToJSONTyped,
} from './SearchPreset';

/**
 * 
 * @export
 * @interface SearchPresetsResponse
 */
export interface SearchPresetsResponse {
    /**
     * 
     * @type {Array<SearchPreset>}
     * @memberof SearchPresetsResponse
     */
    presets: Array<SearchPreset>;
}

/**
 * Check if a given object implements the SearchPresetsResponse interface.
 */
export function instanceOfSearchPresetsResponse(value: object): value is SearchPresetsResponse {
    if (!('presets' in value) || value['presets'] === undefined) return false;
    return true;
}

export function SearchPresetsResponseFromJSON(json: any): SearchPresetsResponse {
    return SearchPresetsResponseFromJSONTyped(json, false);
}

export function SearchPresetsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPresetsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'presets': ((json['presets'] as Array<any>).map(SearchPresetFromJSON)),
    };
}

export function SearchPresetsResponseToJSON(json: any): SearchPresetsResponse {
    return SearchPresetsResponseToJSONTyped(json, false);
}

export function SearchPresetsResponseToJSONTyped(value?: SearchPresetsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'presets': ((value['presets'] as Array<any>).map(SearchPresetToJSON)),
    };
}

